import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { AppConfigService } from '@services/app-config.service';
import { Observable, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DownloadSdk extends SdkBase {

    constructor(private http: HttpClient, private appConfigService: AppConfigService, injector: Injector) {
        super(injector);
    }

    public getProductionDownloadUrls(productionJobId: string): Observable<{ downloadUrls: string[] }> {
        return this.makeHttpRequest<{
            downloadUrls: string[]
        }>('get', `api2/downloads/productions/${ productionJobId }`);
    }

	public getSharedProductionDownloadUrls(request: SharedProductionAccessRequest): Observable<{ status: number, downloadUrls: string[] }> {
		return this.http.post<{ status: number, downloadUrls: string[] }>(`${this.appConfigService.getConfig().webApi}/api2/downloads/shared-productions/${request.sharedProductionJobId}`,
			request,
			{ "observe": "response" }).pipe(map((response: HttpResponse<{ status: number, downloadUrls: string[] }>) => {
				return {
					status: response.status,
					downloadUrls: response.body?.downloadUrls,
				}
			}));
	}

	public getSharedProductionDownloadParts(request: SharedProductionAccessRequest): Observable<{ status: number, parts: string[] }> {
		return this.http.post<{ status: number, downloadUrls: string[] }>(`${this.appConfigService.getConfig().webApi}/api2/downloads/shared-productions/${request.sharedProductionJobId}`,
			request,
			{ "observe": "response" }).pipe(map((response: HttpResponse<{ status: number, downloadUrls: string[] }>) => {
				return {
					status: response.status,
					parts: response.body?.downloadUrls,
				}
			}));
	}

	public getSharedProductionDownloadUrl(request: SharedProductionAccessRequest): Observable<{ status: number, downloadUrl: string }> {
		return this.http.post<{ status: number, downloadUrls: string[] }>(`${this.appConfigService.getConfig().webApi}/api2/downloads/shared-productions/${request.sharedProductionJobId}/part/${request.index}`,
			request,
			{ "observe": "response" }).pipe(map((response: HttpResponse<{ status: number, downloadUrls: string[] }>) => {
				return {
					status: response.status,
					downloadUrl: response.body?.downloadUrls[0],
				}
			}));
	}

}

export interface SharedProductionAccessRequest {
	productionJobId?: string;
	sharedProductionJobId: string;
	password?: string;
	emailAddress?: string;
	index?: number;
	part?: string;
}
